import * as types from '../mutation-types';
const state = {
  readBidState: false,
};
const getters = {
  getReadBid: (state) => state.readBidState,
};
const actions = {
  async setReadBid({ commit }, obj) {
    commit(types.GET_READBID_STATUS, obj);
  },
};
const mutations = {
  [types.GET_READBID_STATUS](state, obj) {
    state.readBidState = obj;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
